import { useMemo } from 'react';
import { IntlFormatters, MessageDescriptor, useIntl } from 'react-intl';
import { z } from 'zod';

/**
 * Builds the base Zod schema shared by social export publish forms (e.g. publishAt).
 */
export function createBaseExportSchema(t: IntlFormatters['$t']) {
  return z.object({
    publishAt: z
      .string()
      .nullable()
      .refine(
        (value) => {
          if (!value) return true;
          const minDateTime = new Date(Date.now() + 2 * 60 * 1000);
          return new Date(value) > minDateTime;
        },
        {
          message: t({
            id: 'socialExport.validation.futureDate',
            defaultMessage: 'Date must be in the future',
          }),
        },
      ),
  });
}

/** Returns the base social export publish schema with translated validation messages. */
export function useBaseExportSchema() {
  const { $t } = useIntl();
  return useMemo(() => createBaseExportSchema($t), [$t]);
}

/**
 * @deprecated Use useBaseExportSchema() for translated messages
 */
export const baseExportSchema = createBaseExportSchema((msg: MessageDescriptor) => {
  const { defaultMessage } = msg;
  return typeof defaultMessage === 'string' ? defaultMessage : '';
});
